var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAdvantages5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2141,
    height: 37,
    viewBox: "0 0 2141 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.01 18.4609H0.730713",
    stroke: "url(#paint0_linear_3052_1058)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2141.01 0.457031H2105.01V36.457H2141.01V0.457031Z",
    fill: "#71253C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_1058",
    x1: 0.730713,
    y1: 18.9609,
    x2: 2105.01,
    y2: 18.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71253C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_1058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2141,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAdvantages5);
export default __webpack_public_path__ + "static/media/line-Advantages5.237a09e8414f13b0ddf6015033cb562a.svg";
export { ForwardRef as ReactComponent };